define('ordersDetailOrderCommentsEditView',[
  'module',
  'underscore',
  'settings',
  'commentsTagsView',
  'commentEditView',
  'template!ordersDetailOrderCommentsEditView'
], function(
  Module,
  _,
  Settings,
  TagsView,
  CommentEditView,
  Tpl
) {
  'use strict';

  Module.exports = CommentEditView.extend({
    template: Tpl,
    className: 'order-comment-edit-view ' + CommentEditView.prototype.className,
   
    regions: _.extend( {
      tagsRegion: '.tags-region'
    }, CommentEditView.prototype.regions), 

    onRender: function() {
      CommentEditView.prototype.onRender.apply(this, arguments);

      //-----------------
      if(Settings.configValue('advancedMode') === true) {
        this.tagsView = new TagsView({
          multiSelect: true
        });
        this.getRegion('tagsRegion').show(this.tagsView);      
        
        var tags = [];

        if(this.model.get('tags') && this.model.get('tags') !== '')
          tags = this.model.get('tags').split(',');

        _.each(tags, _.bind(function(tag) {
          this.tagsView.setSelected(tag, true);
        }, this));
      }
    },   

    onConfirm: function () {
      this.ui.textarea.trumbowyg('execCmd', {cmd: 'blur'});
      var value = this.ui.textarea.trumbowyg('html');
      value = value.replace(/<p><\/p>/g, '');
      value = value.replace(/<p>\n<\/p>/g, '');
      if(this.options.onConfirm) {
        if(Settings.configValue('advancedMode') === true) {
          this.options.onConfirm(value, this.tagsView.getSelected());
        } else {
          this.options.onConfirm(value);
        }
      }
        
      this.windowView.close();
    },

    // Static methods
    open: function (data) {
      require([
        'windows',
        'ordersDetailOrderCommentsEditView'
      ], function (Windows, View) {
        var title = '';
        if(data.title)
          title = data.title;
        Windows.open({
          view: _.bind(function () {
            return new View(data);
          }, this),
          modal: true,
          title: title,
          width: '60%',
          maxHeight: 600
        });
      });
    }
  });
});
